/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiClient } from '@shared/api-client';
import { Customer } from '@shared/models';
import { forkJoin, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomersService extends ApiClient {
  constructor(private httpClient: HttpClient) {
    super();
  }

  getCustomers(itemsPerPage: number = 500): Observable<Customer[]> {
    return this.requestCustomers(1, 0).pipe(
      switchMap((response: any): any => {
         return forkJoin(
           Array.from({
             length: Math.ceil(response['hydra:totalItems'] / itemsPerPage)
           }, (_, index) => this.requestCustomers(index + 1, itemsPerPage))
         );
      }),
      map((responses: Array<Customer[]>) => {
        let customers = [];
        responses.forEach(response => customers = customers.concat(response['hydra:member']));
        return customers;
      }),
    );
  }

  requestCustomers(page: number, itemsPerPage: number): any {
    return this.httpClient.get<Customer[]>(
      environment.backendServer + `/api/customers?itemsPerPage=${itemsPerPage}&page=${page}`,
      {
        headers: this.LD_JSON_HEADERS
      });
  }

  getCustomersStartWith(searchString: string): Observable<Customer[]> {
    const params: any = {
      search: searchString
    };
    return this.httpClient.get<Customer[]>(
      environment.backendServer + '/api/customers',
      {
        headers: this.LD_JSON_HEADERS,
        params
      }
    ).pipe(
      map(response => response['hydra:member'])
    );
  }
}
